import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import style from "./Home.module.css";
import bgVideo from "../../assets/vid.mp4";
import bgVideo2 from "../../assets/Esports.mp4"
import bgVideo3 from "../../assets/videoplayback.mp4";
import redpc from "../../assets/redpc.jpg";
import credit from "../../assets/credit.jpg";
import { ContactUs } from "./ContactUs/ContactUs";
import ImgSlider from "../Upgrade/ImgSlider/ImgSlider";
import Map from "./Map/Map";
import Header from "../Header/Header";
import Footer from "../Footer/Footer"

const Home = () => {
  return (
    <div>
      <Header />
      <Carousel interval={6000} infiniteLoop={true} autoPlay showThumbs={false}>
        <div>
          <video
            className={style.img}
            src={bgVideo3}
            autoPlay
            loop
            muted
          />
        </div>
        <div>
          <video
            className={style.img}
            src={bgVideo}
            autoPlay
            loop
            muted
          />
        </div>
        <div>
          <video
            className={style.img}
            src={bgVideo2}
            autoPlay
            loop
            muted
          />
          <p className={style.video__title}>Calling all Gamers</p>
        </div>
      </Carousel>

      <div className={style.main__motivation}>
        <div className={style.container}>
          <h4 className={style.motivation__title}>What we can do?</h4>
          <p className={style.motivation}>Whether it’s gaming, streaming, creating, or just chilling, everyone has their thing. And the pursuit of your thing – that’s our thing. All the gear we build, all the tech we innovate, all the details we sweat, is for one purpose: to help you do your thing, better.</p>
        </div>
      </div>

      <div className={style.pr}>
        <div className={style.container}>
          <div className={style.products}>
            <div >
              <img className={style.product__photo} src="https://nzxt.com/assets/cms/34299/1654029414-h510-streamingpc-pro-hero-2000x2000.png?ar64=MTox&auto=format&dpr=1.5&fit=crop&fm=webp&h=400&w=400" alt="" />
              <p className={style.product__title}>Gaming desktop</p>
            </div>
            <div>
              <img className={style.product__photo} src="https://nzxt.com/assets/cms/34299/1626205674-starterpc1-white-2000x2000-hero.png?ar64=MTox&auto=format&dpr=1.5&fit=crop&fm=webp&h=400&w=400" alt="" />
              <p className={style.product__title}>Ready to ship desktop</p>
            </div>
            <div>
              <img className={style.product__photo} src="https://cdn.originpc.com/img/compare-all/gaming-laptops/evo15-s-system-image.png" alt="" />
              <p className={style.product__title}>Gaming Laptops</p>
            </div>
            <div>
              <img className={style.product__photo} src="https://www.gallelaptop.lk/images/slider/galle-laptop4.png" alt="" />
              <p className={style.product__title}>Accessories</p>
            </div>
          </div>
        </div>
      </div>

      <div className={style.srvse}>
        <div className={style.container}>
          <h2 className={style.srvse__title}>Why you should choose us?</h2>
          <div className={style.service}>
            <img className={style.sevice__photo} src={redpc} alt="" />
            <div className={style.service__lists}>
              <h3>What makes us the first for 11 years</h3>
              <p>- Official partners of NVIDIA, Intel and Microsoft</p>
              <p>- The most advanced online computer configurator</p>
              <p>- Only the best components and advanced technologies</p>
              <p>- Professional assembly and customization</p>
              <p>- Special stress testing and software installation</p>
              <p>- Delivery, installation and turnkey computer setup</p>
              <p>- Own production</p>
              <p>- Service centers in more than 9 major cities of Tashkent</p>
              <button className={style.glow_on_hover} type="button">Learn More</button>
            </div>
          </div>
        </div>

        <div className={style.container}>
          <div className={style.actions}>
            <div className={style.actions__card}>
              <span>11 years</span>
              <p>For 11 years we have grown into a leader in the gaming market</p>
            </div>
            <div className={style.actions__card}>
              <span>21 000 PC</span>
              <p>We have produced more than 21 thousand gaming computers for our customers</p>
            </div>
            <div className={style.actions__card}>
              <span>30 tournaments</span>
              <p>Held 30 esports tournaments with the technical support of PC Shop</p>
            </div>
            <div className={style.actions__card}>
              <span>64 bloggers</span>
              <p>Top 64 YouTube bloggers and streamers chose the PC Shop computer</p>
            </div>
            <div className={style.actions__card}>
              <span>44 clubs</span>
              <p>Equipped 44 computer clubs on a turnkey basis, there is a leasing program</p>
            </div>
          </div>
        </div>


        <div className={style.credit}>
          <img className={style.credit__photo} src={credit} alt="" />
          <div className={style.container}>
            <p className={style.credit__title}>Play Now,<br /> Pay Later</p>
          </div>
        </div>


        <div className={style.container}>
          <div className={style.cards}>
            <div className={style.card}>
              <span className="material-symbols-outlined">
                monetization_on
              </span>
              <h4 className={style.card__title}>FINANCING</h4>
              <h6 className={style.card_desc}>Play Now and Pay Later</h6>
              <ul>
                <li>Easy to apply</li>
                <li>Get instant pre-approved offers and rates</li>
                <li>Twelve months same as cash available*</li>
                <li>No prepayment penalties</li>
                <li>Up to 36 months of payment options</li>
              </ul>
            </div>

            <div className={style.card}>
              <span className="material-symbols-outlined">
                handshake
              </span>
              <h4 className={style.card__title}>AFFILIATES</h4>
              <h6 className={style.card_desc}>Join the Best</h6>
              <p className={style.cards__description}>Partner up with the best custom PC system builder in the world and earn extra cash! Become An Official PC Engine Affiliate Today!</p>
            </div>

            <div className={style.card}>
              <span className="material-symbols-outlined">
                support_agent
              </span>
              <h4 className={style.card__title}>SUPPORT</h4>
              <h6 className={style.card_desc}>24/7 US Based Support</h6>
              <p className={style.cards__description}>Once you join us, we will have you covered. With every system, PC Engine provides a free phone and online lifetime service guarantee.</p>
            </div>
          </div>
        </div>
      </div>

      <div className={style.contact}>
        <h1>GET INVOLVED &
          JOIN THE COMMUNITY</h1>
        <div>
          <ContactUs />
          <Map />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
